import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'

const routes = [
  {
    path: '/solicitacoes',
    name: 'Solicitacoes',
    component: () => import('../views/compras/Listagem.vue'),
  },
  {
    path: '/solicitacoes/create',
    name: 'Solicitar create',
    component: () => import('../views/compras/Solicitar.vue')
  },
  {
    path: '/solicitacoes/:id/detalhes',
    name: 'detalhes-solicitacao',
    component: () => import('../views/compras/Detalhes.vue')
  },
  {
    path: '/solicitacoes/success',
    name: 'Solicitacao Enviada',
    component: () => import('../views/Sucess.vue')
  },
  {
    path: '/sucesso',
    name: 'Sucesso',
    component: () => import('../views/solicitarAcesso/Sucesso.vue')
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('../views/Error.vue'),
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

router.beforeEach(async (to, from, next) => {
  let token = to.query.tokenLaravel || ''
  let embed = typeof to.query.embed != 'undefined' && to.query.embed == true

  if (token == '') {
    token = store.getters.getTokenLaravel
    if (token !== '') {
      embed = true
    }
  }

  store.dispatch('setTokenLaravel', token)
  store.dispatch('setShowMenu', !embed)

  if (to.path.startsWith('/solicitacoes')) {
    await store.dispatch('fetchUser', {
      Authorization: `Bearer ${token}`
    })
  }

  next()
})

export default router
